function prepareInit(init: any) {
  const update = { ...init };

  if (init.method) {
    update.method = init.method.toUpperCase();
  }

  return { ...init, ...update };
}

function getBaseRequest(input: any) {
  const init = {
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }),
  };

  return new Request(input, init);
}

export function fetchForm(input: any, config = {}) {
  return fetch(getBaseRequest(input), prepareInit(config));
}
